export const baseUrl = 'groups';
